import { render, staticRenderFns } from "./noticeManager.vue?vue&type=template&id=1426100e"
import script from "./noticeManager.vue?vue&type=script&lang=js"
export * from "./noticeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports